import { useFetchState } from './useFetchState';
export function useFetchValue(action, params) {
    const [value] = useFetchState(action, params);
    return value;
}
